import React, { useState } from 'react';
import { Box } from '@mui/material';
import Sidebar from '../Sidebar/Sidebar';
import Topbar from '../Topbar/Topbar';
import { LayoutContainer, MainContent } from './MainLayout.styled';

const MainLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <LayoutContainer>
      <Topbar sidebarCollapsed={sidebarCollapsed} />
      <Box sx={{ display: 'flex', flex: 1, pt: '48px' }}>
        <Sidebar onCollapse={setSidebarCollapsed} />
        <MainContent sidebarCollapsed={sidebarCollapsed}>
          {children}
        </MainContent>
      </Box>
    </LayoutContainer>
  );
};

export default MainLayout; 